/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Notifications_Expiration_HintInputs */

const he_notifications_expiration_hint = /** @type {(inputs: Notifications_Expiration_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`בחרו תווך זמן עבור ההתראה, שאחריו לא נעדכן אתכם כאשר יש שינויים במחיר.`)
};

const en_notifications_expiration_hint = /** @type {(inputs: Notifications_Expiration_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Choose how long to receive notifications. After this period, notifications will stop.`)
};

/**
* | output |
* | --- |
* | "Choose how long to receive notifications. After this period, notifications will stop." |
*
* @param {Notifications_Expiration_HintInputs} inputs
* @param {{ locale?: "he" | "en" }} options
* @returns {LocalizedString}
*/
export const notifications_expiration_hint = /** @type {((inputs?: Notifications_Expiration_HintInputs, options?: { locale?: "he" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Notifications_Expiration_HintInputs, { locale?: "he" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "he") return he_notifications_expiration_hint(inputs)
	return en_notifications_expiration_hint(inputs)
});